module.exports = __webpack_public_path__ + "media/success.3cacefae.mp3";